"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DrawingOnlyNetProcessor = void 0;
class DrawingOnlyNetProcessor {
    static removeDrawingOnlyNets(project) {
        const namesReachingRealComponents = DrawingOnlyNetProcessor.collectNamesReachingRealComponents(project);
        const removed = [];
        for (const [designId, design] of Object.entries(project.designs)) {
            for (const [netName, netInfo] of Object.entries(design.nets)) {
                if (namesReachingRealComponents.has(netName)) {
                    continue;
                }
                if (!DrawingOnlyNetProcessor.isDrawingOnlyNet(project, design, netInfo)) {
                    continue;
                }
                removed.push({
                    designId,
                    netName,
                    moduleNames: netInfo.connections.map((c) => c.moduleName),
                });
                delete design.nets[netName];
                DrawingOnlyNetProcessor.clearPinNetsForNet(design, netName);
            }
        }
        return removed;
    }
    static isDrawingOnlyNet(project, design, netInfo) {
        if (netInfo.connections.length === 0) {
            return false;
        }
        return netInfo.connections.every((connection) => {
            const module = design.modules.find((m) => m.ref === connection.moduleRef);
            if (!module) {
                return true;
            }
            return project.components[module.componentRef]?.isVirtual === true;
        });
    }
    static collectNamesReachingRealComponents(project) {
        const names = new Set(Object.keys(project.globalNets ?? {}));
        for (const design of Object.values(project.designs)) {
            for (const [netName, netInfo] of Object.entries(design.nets)) {
                if (names.has(netName)) {
                    continue;
                }
                const reachesReal = netInfo.connections.some((connection) => {
                    const module = design.modules.find((m) => m.ref === connection.moduleRef);
                    return module !== undefined && project.components[module.componentRef]?.isVirtual !== true;
                });
                if (reachesReal) {
                    names.add(netName);
                }
            }
        }
        return names;
    }
    static clearPinNetsForNet(design, netName) {
        for (const module of design.modules) {
            for (const [pinRef, assigned] of Object.entries(module.pinNets)) {
                if (assigned === netName) {
                    delete module.pinNets[pinRef];
                }
            }
        }
    }
}
exports.DrawingOnlyNetProcessor = DrawingOnlyNetProcessor;
//# sourceMappingURL=DrawingOnlyNetProcessor.js.map